import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '../button/button.module';
import { CardModule } from '../card/card.module';
import { OverlayModule } from '../overlay/overlay.module';
import { ScrollViewModule } from '../scroll-view/scroll-view.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { ContentTemplate, ModalComponent } from './modal.component';

@NgModule({
  imports: [
    CommonModule,
    OverlayModule,
    CardModule,
    ButtonModule,
    ScrollViewModule,
    ToolbarModule,
  ],
  declarations: [ModalComponent, ContentTemplate],
  exports: [ModalComponent, ContentTemplate],
})
export class ModalModule {}
